// Demo data writes REAL rows - invoices and credit notes among them, which
// cannot be deleted once issued. This module decides where that is allowed.
//
// It is an ALLOWLIST and it FAILS CLOSED: a missing, malformed or unrecognised
// Supabase URL means NO. Adding an environment is a deliberate edit here.

const DEMO_ALLOWED_REFS = Object.freeze([
  "zealuaisepkcbxaytdwp",   // msquared-test
]);

// pwvjqkwegbvzasdszwze (PRODUCTION) is deliberately absent and must stay absent.
// Sixteen real businesses are on it and issued invoices cannot be deleted.

/** The Supabase project ref from REACT_APP_SUPABASE_URL, or null if unreadable. */
export function currentProjectRef() {
  const url = (process.env.REACT_APP_SUPABASE_URL || "").trim();
  const m = /^https:\/\/([a-z0-9]+)\.supabase\.co\/?$/i.exec(url);
  return m ? m[1].toLowerCase() : null;
}

/** True only when the current project is explicitly allowlisted above. */
export function demoDataAllowed() {
  const ref = currentProjectRef();
  return ref !== null && DEMO_ALLOWED_REFS.includes(ref);
}

export const DEMO_BLOCKED_MESSAGE =
  "Demo data is disabled on this environment. It creates real invoices and " +
  "credit notes, which cannot be deleted once issued, so it is only permitted " +
  "on the test project.";
